<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="customSpeedosEditForm">
      <div class="field-validation-error"></div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group" aria-required="true">
            <div>
              <div>
                <ng-select
                  [clearable]="false"
                  [items]="speedoItemList"
                  bindLabel="name"
                  bindValue="id"
                  [multiple]="true"
                  groupBy="selectedAllGroup"
                  [selectableGroup]="true"
                  formControlName="indicators"
                  placeholder="Select some options"
                  (change)="selectProduct($event)"
                  [maxSelectedItems]="3"
                >
                </ng-select>
              </div>
            </div>
            <div *ngIf="validationFlag">
              <label class="indicatorsFlag">You can only select any 3 indicators</label>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light cancel-btn modelBtn" (click)="onClose()">
      Cancel
    </button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
